<template lang="html">
  <section 
    class="advanced-settings py-1 px-2" 
    :class="{'bg-white' : showSettings}">
    <div 
        class="d-flex justify-content-between position-relative"
        style="cursor:pointer"
        @click="toggleSettings"
    >
        <h3 
          class="m-0" 
          :class="{'text-primary' : showSettings}">{{hebrew ? 'הגדרות מתקדמות' : 'Advanced settings'}}
          <small 
            style="font-size:7px;top:-3px;" 
            class="position-relative"
            v-if="showSettingsChanges">
            <i class="text-primary fas fa-circle"></i>
          </small>          
        </h3>
        <i v-if="showSettings" class="fas fa-sort-up text-primary" style="margin-top:6px;"></i>
        <i v-if="!showSettings" class="fas fa-sort-down" ></i>
    </div>    
    <div class="settings-wrap" v-if="showSettings">
      <div class="results-mode-wrap py-2 mb-2" v-if="soundPlayWord !== ''">
        <small>{{hebrew ? 'סגנון טקסט' : 'Choose text type'}}</small>
        <div class="custom-control custom-checkbox mt-1 px-0" >
          <b-form-checkbox 
            id="modern-text-cb"
            @change="setModern"
            :checked="modernTextSelected"
          >
            הרשימה המלאה
          </b-form-checkbox>
          </div>
          <div class="custom-control custom-checkbox mt-1 px-0" >
            <b-form-checkbox 
              id="biblical-text-cb"
              @change="setBiblical"
              :checked="biblicalTextSelected"
            >
              {{searchModel === 'rhyme' ? 'חרוזים מהתנ״ך' : 'מילים מהתנ״ך'}}
            </b-form-checkbox>
          </div>  
          <div class="custom-control custom-checkbox mt-1 px-0" >
            <b-form-checkbox 
              id="common-text-cb"
              @change="setCommon"
              :checked="commonTextSelected"
            >
              {{searchModel === 'rhyme' ? 'חרוזים נפוצים' : 'מילים נפוצות'}}
          </b-form-checkbox>                
        </div>             
      </div>
      <div class="first-names pb-2" v-if="selectedAccent==='returnall' || searchModel !=='rhyme'">
        <div class="custom-control custom-checkbox px-0" >
          <small>{{hebrew ? 'שמות פרטיים' : 'First names'}}</small>
          <b-form-checkbox 
            id="first-name-cb"
            v-model="displayNames"              
          >
            {{hebrew  ? 'כלול שמות פרטיים' : 'Display first names'}}
          </b-form-checkbox>                
        </div>    
      </div>
      <AdvancedOptions></AdvancedOptions>
      <SyllableSlider></SyllableSlider>
    </div>
  </section>
</template>

<script lang="js">
  import SyllableSlider from '@/components/SyllableSlider'
  import AdvancedOptions from '@/components/AdvancedOptions'
  import {BlankState, Actions} from '@/store/stateChanges' 
  export default  {
    name: 'AdvancedSettings',
    components: {SyllableSlider, AdvancedOptions},
    props: [],
    mounted() {
      
    },
    data() {
      return {
        showSettings: false,
      }
    },
    methods: {
      toggleSettings () {
        this.showSettings = !this.showSettings
      },
      setOverview () {
        this.$store.commit('SET_OVERVIEW', false)
        if(!this.$store.state.displayBible && !this.$store.state.displayDefault && !this.$store.state.displayCommon) {
          this.$store.commit('SET_OVERVIEW', true)
        }
      },
      setBiblical () {        
        this.$store.state.displayBible = !this.$store.state.displayBible
        this.setOverview()
      },
      setModern () {
        this.$store.state.displayDefault = !this.$store.state.displayDefault
        this.setOverview()
      },
      setCommon () {
        this.$store.state.displayCommon = !this.$store.state.displayCommon
        this.setOverview()
      },
      
    },
    computed: {      
      hebrew () {
        return this.$settings.hebrew
      },
      showSettingsChanges () {      
        if (this.searchModel === 'rhyme') {
          return this.syllableChanges
        } 
        else if (this.searchModel === 'xxsonance') {
          return this.syllableChanges
            || this.$store.state.preSubmissionOptions.displayConsonance !== BlankState.preSubmissionOptions.displayConsonance
            || this.$store.state.preSubmissionOptions.displayAssonance !== BlankState.preSubmissionOptions.displayAssonance
            || this.$store.state.preSubmissionOptions.displayNames !== BlankState.preSubmissionOptions.displayNames
        }
        else {
          return this.syllableChanges
          || this.$store.state.preSubmissionOptions.maxConsonant !== BlankState.preSubmissionOptions.maxConsonant
          || this.$store.state.preSubmissionOptions.displayNames !== BlankState.preSubmissionOptions.displayNames
        } 
      },
      syllableChanges () {
        return  parseInt(BlankState.preSubmissionOptions.maxSyllable) !== parseInt(this.$store.state.preSubmissionOptions.maxSyllable)
          || parseInt(BlankState.preSubmissionOptions.minSyllable) !== parseInt(this.$store.state.preSubmissionOptions.minSyllable)
      },
      selectedAccent () {
        return this.$store.state.preSubmissionOptions.accent
      },
      soundPlayWord () {
        return this.$store.state.textForCharuzitApiCall
      },   
      modernTextSelected () {
        return this.$store.state.displayDefault
      },
      biblicalTextSelected () {
        return this.$store.state.displayBible
      },
      commonTextSelected () {
        return this.$store.state.displayCommon
      },
      searchModel () {
        return this.$store.state.searchModel
      },
      displayNames: {
        get () {
          return this.$store.state.preSubmissionOptions.displayNames
        },  
        set (value) {
          this.$store.commit('SET_DISPLAY_NAMES',  value)
          this.$store.dispatch(Actions.RUN_CHARUZIT)
        }        
      },      
    }
}
</script>
 
 <style>
  .advanced-settings {
    border-top: 1px solid #c8c8c8;
    border-bottom: 1px solid #c8c8c8;
  }
  .custom-control i:hover {
    cursor: pointer;
  }
  .first-names,
  .results-mode-wrap {
    border-bottom: 1px dashed #c8c8c8;
  }
 </style>